<template>
  <div>
<!--    预览模式-->
    <div @click="handleClick" class="waterPine" :style="style1" v-if="this.realtimeData.state === true && mode === 'view'&&settings.transform === 'rotate(0deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 20px;height: 100%;display: flex">
        <div :class="['waterRectOdd', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite'}"></div>
        <div :class="['waterRectEven', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite', backgroundColor: ''+waterColor}"></div>
      </div>

    </div>
    <div @click="handleClick" class="waterPine" :style="style1" v-if="this.realtimeData.state === true && mode === 'view'&& settings.transform === 'rotate(180deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 20px;height: 100%;display: flex">
        <div :class="['waterRectOdd', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite reverse'}"></div>
        <div :class="['waterRectEven', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite reverse',  backgroundColor: ''+waterColor}"></div>
      </div>

    </div>

    <div @click="handleClick" class="waterPineHeight" :style="style1" v-if="this.realtimeData.state === true && mode === 'view'&&settings.transform === 'rotate(90deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 100%;height: 20px;display: flex;flex-direction:column">
        <div :class="['waterRectOdd', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite'}"></div>
        <div :class="['waterRectEven', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite', backgroundColor: ''+waterColor}"></div>
      </div>

    </div>
    <div @click="handleClick" class="waterPineHeight" :style="style1" v-if="this.realtimeData.state === true && mode === 'view'&& settings.transform === 'rotate(270deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 100%;height: 20px;display: flex;flex-direction:column">
        <div :class="['waterRectOdd', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite reverse'}"></div>
        <div :class="['waterRectEven', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite reverse',  backgroundColor: ''+waterColor}"></div>
      </div>
    </div>
<!--    编辑模式-->
    <div class="waterPine" :style="style1" v-if="mode === 'edit'&&settings.transform === 'rotate(0deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 20px;height: 100%;display: flex">
        <div :class="['waterRectOdd', 'waterRect']" :style="{animation: 'move_waterRect '+ time+'s linear infinite'}"></div>
        <div :class="['waterRectEven', 'waterRect']" :style="{animation: 'move_waterRect '+ time+'s linear infinite', backgroundColor: ''+waterColor}"></div>
      </div>


    </div>
    <div class="waterPine" :style="style1" v-if="mode === 'edit'&& settings.transform === 'rotate(180deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 20px;height: 100%;display: flex">
        <div :class="['waterRectOdd', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite reverse'}"></div>
        <div :class="['waterRectEven', 'waterRect']" :style="{Animation: 'move_waterRect '+ time+'s linear infinite reverse',  backgroundColor: ''+waterColor}"></div>
      </div>

    </div>

    <div class="waterPineHeight" :style="style1" v-if="mode === 'edit'&&settings.transform === 'rotate(90deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 100%;height: 20px;display: flex;flex-direction:column">
        <div :class="['waterRectOdd', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite'}"></div>
        <div :class="['waterRectEven', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite', backgroundColor: ''+waterColor}"></div>
      </div>

    </div>
    <div class="waterPineHeight" :style="style1" v-if="mode === 'edit'&& settings.transform === 'rotate(270deg)'">
      <div class="waterRectContainer" v-for="i in 200" :key="i" style="width: 100%;height: 20px;display: flex;flex-direction:column">
        <div :class="['waterRectOdd', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite reverse'}"></div>
        <div :class="['waterRectEven', 'waterRectHeight']" :style="{Animation: 'move_waterRectHeight '+ time+'s linear infinite reverse',  backgroundColor: ''+waterColor}"></div>
      </div>

    </div>

    <el-dialog :style="dialogStyle"
        title="子窗口页面"
        :visible.sync="modalShow"
        :width="realtimeData.modalValue+'px'"
        @close="modalShow=false"
        append-to-body>
      <div :style="modelStyle">
        <div style="width: 100%; ">
          <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId"
                      :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1"
                      :readPublished="true"></the-create>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import componentsMixin from "../componentsMixin";

export default {
  name: "pipelineComponent",
  mixins: [componentsMixin],
  data() {
    return {
      state: true, //控制显示和消失
      nowWidth: 0,  //此处记录水流的宽度，计算需要多少水流
      nowHeight: 0,  //此处记录水流的高度，计算需要多少水流
      widthNum: 0, //宽度除以每个水流的长度
      heightNum: 0,//高度除以每个水流的长度
      widthRemainder: 0,//余数
      heightRemainder: 0,//余数
      typeWidth: 0, //记录拉动的宽度或者长度的类型，0偶整数200，1偶余数203，2奇整数190，3奇余数193
      typeHeight: 0,
      dynamicWidthHtml:'', //动态生成的html
      dynamicHightHtml:'',
      time:0,
      waterColor:'',
    }
  },
  mounted() {
      let speed = parseFloat(this.realtimeData.speed)
      this.time = 3.0 / speed;
      this.waterColor = this.realtimeData.background;
      this.init();
  },
  methods: {
    init() {
      //高度的
      this.nowHeight = this.realtimeData.height;
      let midHeight = Math.floor(this.nowHeight / 10);
      this.heightRemainder = this.nowHeight % 10;
      let yushuHeight = this.nowHeight % 10;
      if (midHeight % 2 == 0) {
        {
          if (yushuHeight == 0) {  //偶整数
            this.heightNum = Math.floor(midHeight / 2) + 1;
            this.typeHeight = 0;
          } else if (yushuHeight !== 0) { //偶余数
            this.heightNum = Math.floor(midHeight / 2) + 1;
            this.typeHeight = 1;
          }
        }
      }
      if (midHeight % 2 !== 0) {
        if (yushuHeight == 0) {//奇整数
          this.heightNum = Math.floor(midHeight / 2) + 1;
          this.typeHeight = 2;
        } else if (yushuHeight !== 0) {//奇余数
          this.heightNum = Math.floor(midHeight / 2) + 2;
          this.typeHeight = 3;
        }
      }
      //宽度的
      this.nowWidth = this.realtimeData.width;
      let mid = Math.floor(this.nowWidth / 10);
      this.widthRemainder = this.nowWidth % 10;
      let yushu = this.nowWidth % 10;
      if (mid % 2 == 0) {
        {
          if (yushu == 0) {  //偶整数
            this.widthNum = Math.floor(mid / 2) + 1;
            this.typeWidth = 0;
          } else if (yushu !== 0) { //偶余数
            this.widthNum = Math.floor(mid / 2) + 1;
            this.typeWidth = 1;
          }
        }
      }
      if (mid % 2 !== 0) {
        if (yushu == 0) { //奇整数
          this.widthNum = Math.floor(mid / 2) + 1;
          this.typeWidth = 2;
        } else if (yushu !== 0) {//奇余数
          this.widthNum = Math.floor(mid / 2) + 2;
          this.typeWidth = 3;
        }
      }
      this.widthRemainder = this.nowWidth % 10;

      // this.buildWidthWater();
      // this.buildHeightWater();
    },
    // buildHeightWater() {
    //   let hightStructure = "";
    //   for (let i = 0; i < 11; i++) {
    //     hightStructure = hightStructure + '<div id="height' + i + '":style="styleWaterRotate(' + i + ')">' + '</div>';
    //   }
    //   console.log('结构', hightStructure)
    //   this.dynamicHightHtml = hightStructure;
    // },
    // buildWidthWater() {
    //   let widthStructure = "";
    //   for (let i = 0; i < 11; i++) {
    //     widthStructure = widthStructure + '<div id="width' + i + '":style="'+this.styleWater(i)+'">' + '</div>';
    //
    //   }
    //   console.log('结构', widthStructure)
    //   this.dynamicWidthHtml = widthStructure;
    // },

    appearPipeline() {
      this.settings.state = true
    },
    disappearPipeline() {
      this.settings.state = false
    },
  },
  computed: {
    style1() {
      let res = this.style;
      res['border-color'] = this.realtimeData.borderColor;
      return res;
    },
    dialogStyle(){
      if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
        var applyLeft = '0'
        var applyTop = '0'
      }else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = '0'
        var applyTop = '0'
      }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = this.realtimeData.modalX
        var applyTop = '0'
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
        var applyLeft = '0'
        var applyTop = this.realtimeData.modalY
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
        var applyLeft = this.realtimeData.modalX
        var applyTop = this.realtimeData.modalY
      }
      return {
        top:`calc(${applyTop}px + 10vh)`,
        left: applyLeft + 'px',
      }
    },
  },
  watch: {
    'realtimeData.speed': {  //监听
      handler(newVal, oldVal) {
        let speed = parseFloat(this.realtimeData.speed)
        this.time = 3.0 / speed;
      }
    },
    'realtimeData.background': {  //监听
      handler(newVal, oldVal) {
        this.waterColor = this.realtimeData.background;
      }
    },
    'time':{
      handler(){
        console.log('更新时间',this.time);
      }
    },
    'settings.transform': {  //监听
      handler(newVal, oldVal) {
        console.log('方向', this.settings.transform)
      }
    },
    'realtimeData.height': {  // 高度绑定
      handler(newVal, oldVal) {
        this.nowHeight = this.realtimeData.height;
        let midHeight = Math.floor(this.nowHeight / 10);
        this.heightRemainder = this.nowHeight % 10;
        let yushuHeight = this.nowHeight % 10;
        if (midHeight % 2 == 0) {
          {
            if (yushuHeight == 0) {  //偶整数
              this.heightNum = Math.floor(midHeight / 2) + 1;
              this.typeHeight = 0;
            } else if (yushuHeight !== 0) { //偶余数
              this.heightNum = Math.floor(midHeight / 2) + 1;
              this.typeHeight = 1;
            }
          }
        }
        if (midHeight % 2 !== 0) {
          if (yushuHeight == 0) {//奇整数
            this.heightNum = Math.floor(midHeight / 2) + 1;
            this.typeHeight = 2;
          } else if (yushuHeight !== 0) {//奇余数
            this.heightNum = Math.floor(midHeight / 2) + 2;
            this.typeHeight = 3;
          }
        }
        console.log('eeeee', this.nowHeight, this.heightNum, this.heightRemainder);
        // this.buildHeightWater();  //随时计算高度上的水流个数和css
      }
    },
    'realtimeData.width': {  // 宽度绑定
      handler(newVal, oldVal) {
        this.nowWidth = this.realtimeData.width;
        let mid = Math.floor(this.nowWidth / 10);
        this.widthRemainder = this.nowWidth % 10;
        let yushu = this.nowWidth % 10;
        if (mid % 2 == 0) {
          {
            if (yushu == 0) {  //偶整数
              this.widthNum = Math.floor(mid / 2) + 1;
              this.typeWidth = 0;
            } else if (yushu !== 0) { //偶余数
              this.widthNum = Math.floor(mid / 2) + 1;
              this.typeWidth = 1;
            }
          }
        }
        if (mid % 2 !== 0) {
          if (yushu == 0) { //奇整数
            this.widthNum = Math.floor(mid / 2) + 1;
            this.typeWidth = 2;
          } else if (yushu !== 0) {//奇余数
            this.widthNum = Math.floor(mid / 2) + 2;
            this.typeWidth = 3;
          }
        }
        console.log('eeeee', this.nowWidth, this.widthNum, this.widthRemainder);
        // this.buildWidthWater();//随时计算宽度上的水流个数和css
      }
    },

  }
}
</script>

<style lang="less">
.waterPine {
  position: absolute;
  display: flex;
  justify-content: center;
  overflow: hidden;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.waterPineHeight {
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction:column;
  overflow: hidden;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.waterRect{
  //animation: move_waterRect 0.3s  linear infinite;
  height:100%;
  width:10px;
  //background-color: #0155f5;
}
.waterRectHeight{
  height:10px;
  width:100%;
}
.waterRectEven {
  //background-color: #0155f5;
}
.waterRectOdd {
  background-color: white;
}
@keyframes move_waterRectFirst {
  0% {
    width: 0;
    left: 0;
    height: 100%;
  }
  100% {
    width: 10px;
    left: 0;
    height: 100%;
    background: red;
  }
}

@keyframes move_waterRect {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes move_waterRectHeight {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
}
::v-deep .el-dialog{
  margin:0 !important;
  position:absolute;
}
</style>
